import { UserDashboardQuery } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import Link from 'next/link';
import { useMemo } from 'react';
import { Alert } from 'react-bootstrap';
import { getBalanceOutstanding } from '../bookings/sections/BookingInvoice';

type Props = {
  bookings: UserDashboardQuery['user']['bookings']['items'];
};

export default function BookingBalanceOutstandingAlert({ bookings }: Props) {
  const balanceOutstanding = useMemo(() => {
    return (
      bookings
        .filter(
          (booking) =>
            booking.spaces.filter((space) => space.active).length > 0,
        )
        .filter((booking) => {
          const isTripDeparted =
            DateTime.fromISO(booking.group.start.utc).diffNow().as('days') < 1;
          return !isTripDeparted;
        })
        .map((booking) => {
          const starts = DateTime.fromISO(booking.group.start.utc)
            .setZone(booking.group.start.zone)
            .toFormat('LLL yyyy');

          const daysToStart = DateTime.fromISO(booking.group.start.utc)
            .diffNow()
            .as('days');

          return {
            id: booking.id,
            userID: booking.user.id,
            trip: `Please pay outstanding balance for ${booking.trip.title} (${starts})`,
            balance: getBalanceOutstanding(booking),
            daysToStart,
          };
        })
        // if balance is greater than 0 and days to start is less than 60, show alert
        .filter((booking) => booking.balance > 0 && booking.daysToStart < 91)
    );
  }, [bookings]);

  return (
    <>
      {balanceOutstanding?.map(({ balance, trip, userID, id }) => (
        <Alert key={balance} variant="danger" className="mt-3">
          {balance > 0 && (
            <Link
              href={`/me/${userID}/bookings/${id}/pay`}
              legacyBehavior
              passHref
            >
              <Alert.Link>{trip}</Alert.Link>
            </Link>
          )}
        </Alert>
      ))}
    </>
  );
}
